import { CSSObject, Theme, getFontWeight } from '@core-ui/react-stitch';

export const getTextStyles = (isBRRedesignEnabled: boolean): CSSObject => ({
  ...isBRRedesignEnabled ? {
    fontWeight: getFontWeight('regular').fontWeight,
    fontSize: '1rem'
  } : {}
});

export default getTextStyles;
